export const formatCurrency = (amount: number | undefined | null): string => {
  if (amount === undefined || amount === null) return "-";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
};

export const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR");
  } catch {
    return "Date invalide";
  }
};

export const formatDateTime = (dateString: string): string => {
  return new Date(dateString).toLocaleString("fr-FR");
};

export const formatFileName = (fileName: string, maxLength: number = 25): string => {
  if (!fileName) return "Pas de fichier";
  if (fileName.length <= maxLength) return fileName;

  const extension = fileName.split(".").pop() || "";
  const name = fileName.substring(0, fileName.length - extension.length - 1);
  const truncatedLength = maxLength - 5;

  if (name.length <= truncatedLength) return fileName;

  return `${name.substring(0, truncatedLength)}...${extension ? "." + extension : ""}`;
};

/**
 * Part d'une facture partagée : le serveur la stocke en FRACTION (0,5) et la
 * multiplie telle quelle ; l'écran la montre et la saisit en POURCENTAGE (50).
 * Taper 50 imputait 50 fois la facture (ticket #12).
 */
export const fractionVersPourcentage = (fraction: number): number => Math.round(fraction * 10000) / 100;
export const pourcentageVersFraction = (pourcentage: string): number => parseFloat(pourcentage) / 100;
